type MockOptions = 'NOTICE' | 'IDCARD' | 'MEMBERSHIPS' | 'COVERAGE' | 'PATIENT' | 'EOB'

export function useMock(option: MockOptions): boolean {
	const enabledList = import.meta.env.VITE_FEATURE_MOCK_OPTIONS as MockOptions
	return enabledList?.split(',')?.includes(option)
}

export async function fetchPostmanMbp(body: MbpBody): Promise<any> {
	const url = `${import.meta.env.VITE_PST_MBP_URL}/api/v1/${body.url}`
	return await fetch(url, {
		headers: {
			'X-API-Key': import.meta.env.VITE_PST_KEY
		}
	}).then((result) => {
		if (!result.ok) throw new Error()

		return result.json()
	})
}

export async function fetchPostmanFHIR(body: FhirBody): Promise<any> {
	const url = `${import.meta.env.VITE_PST_FHIR_URL}/${body.url}`
	return await fetch(url, {
		headers: {
			'X-API-Key': import.meta.env.VITE_PST_KEY
		}
	}).then((result) => {
		if (!result.ok) throw new Error()

		return result.json()
	})
}
